module.exports = __webpack_public_path__ + "static/media/tg.2e52a04f.webp";